import { faCaretDown, faExchangeAlt, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from 'auth/AuthContext';

import React, { useEffect, useState } from 'react';

import { S } from './MainHeader.styles';
import siconfiPages from 'config/siconfi.config';

function Credenciais({className, credentials}) {
  const [dropdownOpen, setDropDownOpen] = useState(false);
  const { remoteLogout, reverseSignOn, isAuthenticated} = useAuth()

  useEffect(() => {
    const onAnyWindowClickSetDropDownFalse = () => dropdownOpen && setDropDownOpen(false);
    
    window.addEventListener('click', onAnyWindowClickSetDropDownFalse, false);
    return () => window.removeEventListener('click', onAnyWindowClickSetDropDownFalse, false)
  }, [dropdownOpen])

  function handleToggleDropdown() {
    setDropDownOpen(actualDropdownOpen => !actualDropdownOpen);
  }

  function handleAcessarAreaRestrita() {
    window.location.href = siconfiPages.LOGIN_AREA_RESTRITA;
  }

  return(
    <> 
    {isAuthenticated &&
      <S.Credenciais className={className} role="group">
          <div>
            <div>
              <var>{ credentials.nome }</var>
            </div>
            <div>
              <var> { credentials.orgao }</var>
            </div>
            <div>
              <var> { credentials.nomePerfil } </var>
            </div>
          </div>

          <button className="credenciais__toggle" type="button" onClick={ handleToggleDropdown } >
            <FontAwesomeIcon icon={faCaretDown} />
          </button>

          {
            dropdownOpen && (
              <div className="credenciais__dropdown">
                <S.SessionActionBtn onClick={reverseSignOn} >
                  <div>Acesso aos módulos</div>
                  <FontAwesomeIcon icon={faExchangeAlt} />
                </S.SessionActionBtn>

                <S.SessionActionBtn type="button" onClick={remoteLogout} >
                  <div>Sair com segurança</div>
                  <FontAwesomeIcon icon={faPowerOff} /> 
                </S.SessionActionBtn>
            </div>
          )
        }
      </S.Credenciais>}
    
    {!isAuthenticated &&
      <S.Credenciais className={className} role="group" style={{display:'block'}}>
        <button className="credenciais__toggle bold button" type="button" title="Acessar área restrita do Siconfi" onClick={handleAcessarAreaRestrita} style={{width:'12em', height:'40px'}}>
            <span>Acessar área restrita</span>
        </button>
      </S.Credenciais>
    }
    </>
  );
}

export default Credenciais;
